<template>
    <div>
        <div>
            <div class="divCenter">
                <h4 class="mb-3 lead">Ebay CSV-Datei hochladen</h4>
                <form>
                    <div class="p-2 bg-light">
                        <b-form-file
                                v-model="file1"
                                :state="Boolean(file1)"
                                placeholder="Datei auswählen"
                                @change="fileUploaded"
                                drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </div>

                    <div class="d-flex justify-content-center">
                    <button class="w-25  btn btn-dark mt-4 " style="text-align:center" @click.prevent="create_csv">Rechnungen erstellen</button>
                    </div>
                    <div class="d-flex justify-content-center"> 
                    <button class="w-25  btn btn-dark mt-4 " style="text-align:center" @click.prevent="send_mails()">Emails senden</button>
                    </div>
                </form>


            </div>
        </div>
    </div>


</template>


<script>

    import Api from './api'
    import moment from 'moment'
    import {downloadExceFromJson} from "@/utils.mjs";
                

    export default {
        data() {
            return {
                upload_sizes: {},
                file1: null,
                isLoadingData: false,
            }
        },

        methods: {

            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },


            create_csv() {
                try
                 {
                    this.isLoadingData = true
                    Api.ebay_invoice.invoice_csv(this.file1)
                    .then(result => {

                          if(result.status === 200){
                            this.downloadCSVData(result.data)
                            this.makeToast('success', "Datei erfolgreich erstellt.", "Erfolgreich erstellt.")
                 }else {
                        this.makeToast('danger', "Datei konnte nicht erstellt werden", 'Fehler')
                        }
                    })
                        .catch(e => {
                          this.makeToast('danger', "Datei konnte nicht erstellt werden. Fehler: " + e.message, 'Fehler')
                        })
                
                    }catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Erstellen.")
                 }

            },

            downloadCSVData(csv){
                let formatted_date = moment(new Date()).format('DD-MM-YYYY_HH-mm')
                downloadExceFromJson(csv, `eBay_Labels_${formatted_date}`);

            },
            send_mails(){
                try
                 {
                    this.isLoadingData = true
                    Api.ebay_invoice.send_mail()
                    .then(result => {
                          if(result.status === 200){
                    this.makeToast('success', "Emails erfolgreich verschickt.", "Erfolgreich verschickt.")
                            }else {
                                    this.makeToast('danger', "Emails konnte nicht verschickt werden", 'Fehler')
                                    }
                                })
                        .catch(e => {
                          this.makeToast('danger', "Emails konnte nicht verschickt werden. Fehler: " + e.message, 'Fehler')
                        })
                
                    }catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Verschicken.")
                 }

            },

            
            fileUploaded(e) {
                try {
                    let file = e.currentTarget.files ? e.currentTarget.files[0] : e.dataTransfer.files[0];
                    if (!file.name.endsWith(".csv")) {
                        throw new Error("Falsches format! Erwartet: .csv")
                    }
                    this.makeToast('success', "Datei erfolgreich hochgeladen.", "Erfolgreich hochgeladen.")
                } catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen.")
                }
            }
        },

    }
</script>

<style>
    .hl-dropdown {
        width: 200px;
    }

    .divCenter {
        padding-top: 20px;
        margin-left: 30%;
        margin-right: 30%;
    }

    .centerLoadingBar{
        text-align: center;

    }


    .table-condensed {
        font-size: 12px;
    }

    .sku-input{
        margin-top: 5px;
        margin-bottom: 5px;
    }

</style>
